import { norlizeColumns } from 'utils/handle'
import { StatusValidDisplayEnmus } from 'utils/enmus'



// 项目干系人
const ProjectContactPersonMaps = new Map()
ProjectContactPersonMaps.set('post', '联系人职位')
ProjectContactPersonMaps.set('name', '联系人姓名')
ProjectContactPersonMaps.set('role', '项目角色')
ProjectContactPersonMaps.set('contactInfo', '联系方式')
ProjectContactPersonMaps.set('potentialImpact', '对项目潜在印象')
ProjectContactPersonMaps.set('createTime', '创建时间')

class ProjectContactPerson {
    constructor(v) { // 构造函数
        v = v || {}
    }

    static get tableColumns () {
        return norlizeColumns(
            ['index, 50', 'name', 'post', 'role', 'contactInfo', 'potentialImpact', 'createTime'],
            ProjectContactPersonMaps
        )
    }
}

// 版本管理
const VersionMaps = new Map()
VersionMaps.set('version', '版本号')
VersionMaps.set('acceptanceCriteria', '验收标准')
VersionMaps.set('createTime', '创建时间')
VersionMaps.set('resourcePool', '资源池')
VersionMaps.set('riskPool', '风险池')
VersionMaps.set('costResource', '已耗资源')
VersionMaps.set('laveResource', '剩余资源')
VersionMaps.set('finishedTestProgressRate', '实际进度')

class Version {
    constructor(v) { // 构造函数
        v = v || {}
    }

    static get tableColumns () {
        return norlizeColumns(
            ['version', 'acceptanceCriteria', 'createTime', 'resourcePool', 'riskPool', 'costResource', 'laveResource', 'finishedTestProgressRate'],
            VersionMaps
        )
    }
}


export {
    ProjectContactPerson,
    Version
}


// WEBPACK FOOTER //
// ./src/views/project-manage/projectDTO.js